import Blank from "./views/blank.vue";
import Queue from "./views/queue.vue";
import TestFiles from "./views/test-files.vue";
// import analysisRequests from "./analysis-requests.vue";
// import trackRequest from "./track-request.vue";
import Transactions from "./views/transactions.vue";
import CloneRequest from "./views/clone-request.vue";
import Settings from "./views/settings.vue";
import TestRequest from "./views/test-request.vue";
import TransactionStatus from "./views/transaction-status.vue";
import SystemStatus from "./views/system-status.vue";
import Reports from "./views/reports.vue";
import Applications from "./views/applications.vue";
import Partners from "./views/partners.vue";
import Register from "./views/register.vue";
import Confirm from "./views/confirm.vue";
import Login from "./views/login.vue";
import ForgotPassword from "./views/forgot-password.vue";
import ResetPassword from "./views/reset-password.vue";
import Workers from "./views/workers.vue";
import System from "./views/system.vue";

export default [
	{
		path: "/",
		component: Blank,
		meta: { title: "Inovise Cloud Admin", access: ["Admin", "User"] },
		name: "blank",
	},
	{
		path: "/login",
		component: Login,
		meta: { title: "Login", access: ["*"] },
		name: "login",
	},
	{
		path: "/transactions",
		component: Transactions,
		meta: { title: "Transactions", access: ["Admin"] },
		name: "transactions",
	},
	{
		path: "/clone/:trackingNumber",
		component: CloneRequest,
		meta: { title: "Clone Request", access: ["Admin"] },
		name: "clone",
	},
	{
		path: "/testfiles",
		component: TestFiles,
		meta: { title: "Test Files", access: ["Admin"] },
		name: "testfiles",
		props: { selectable: true },
	},
	{
		path: "/settings",
		component: Settings,
		meta: { title: "Settings", access: ["Admin"] },
		name: "settings",
	},
	{
		path: "/queue",
		component: Queue,
		meta: { title: "Queue", access: ["Admin"] },
		name: "queue",
	},
	{
		path: "/test",
		component: TestRequest,
		meta: { title: "Test Request", access: ["Admin"] },
		name: "test",
	},
	{
		path: "/transactionstatus/:trackingNumber",
		component: TransactionStatus,
		meta: { title: "Transaction Status", access: ["Admin"] },
		name: "transactionstatus",
	},
	{
		path: "/systemstatus/:start?",
		component: SystemStatus,
		meta: { title: "System Status", access: ["Admin"] },
		name: "systemstatus",
	},
	{
		path: "/reports",
		component: Reports,
		meta: { title: "Reports", access: ["Admin"] },
		name: "reports",
	},
	{
		path: "/applications/:id?",
		component: Applications,
		meta: { title: "Applications", access: ["Admin", "User"] },
		name: "applications",
	},
	{
		path: "/partners",
		component: Partners,
		meta: { title: "Partners", access: ["Admin"] },
		name: "partners",
	},
	{
		path: "/register/:token",
		component: Register,
		meta: { title: "Register", access: ["*"] },
		name: "register",
	},
	{
		path: "/confirm/:token",
		component: Confirm,
		meta: { title: "Confirm", access: ["*"] },
		name: "confirm",
	},
	{
		path: "/forgotpassword",
		component: ForgotPassword,
		meta: { title: "Forgot Password", access: ["*"] },
		name: "forgotpassword",
	},
	{
		path: "/reset-password/:token",
		component: ResetPassword,
		meta: { title: "Reset Password", access: ["*"] },
		name: "resetpassword",
	},
	{
		path: "/workers",
		component: Workers,
		meta: { title: "Workers", access: ["Admin"] },
		name: "workers",
	},
	{
		path: "/system",
		component: System,
		meta: { title: "System", access: ["Admin"] },
		name: "system",
	},
];
